// material ui
import { Stack } from '@mui/material';

// api
import { ReadAlarmDto } from '@/api/generated/recalc/endpoints/v1/alarms';

// relative
import MaxThresholdExceeded from './MaxThresholdExceeded.tsx';
import MinThresholdExceeded from './MinThresholdExceeded.tsx';

function renderAlarmSubtype(
  alarmSubType: ReadAlarmDto['AlarmSubtype'],
  metaData: ReadAlarmDto['MetaData'],
  alarm: ReadAlarmDto,
) {
  switch (alarmSubType) {
    case 'MaxThresholdExceeded':
      return <MaxThresholdExceeded alarm={alarm} />;
    case 'MinThresholdExceeded':
      return <MinThresholdExceeded alarm={alarm} />;
    default:
      return <pre>{JSON.stringify(metaData, null, 2)}</pre>;
  }
}

const ThresholdLimit = ({ alarm }: { alarm: ReadAlarmDto }) => {
  console.log('Rendering ThresholdLimit with alarm:', alarm);
  return (
    <Stack spacing={2}>
      {renderAlarmSubtype(alarm.AlarmSubtype, alarm.MetaData, alarm)}
    </Stack>
  );
};

export default ThresholdLimit;
